/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useState } from "react";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  CardText,
  CardTitle,
  Card,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import "../ExploreNearMe/ExploreNearMe.scss";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { showPointList } from "../../utils/action/Action";
import { FiShare2, FiBriefcase } from "react-icons/fi";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";
import { BiDotsVerticalRounded, BiExitFullscreen } from "react-icons/bi";
import { MdLocationOn, MdOutlineNavigateNext } from "react-icons/md";
import SelectRouteModal from "../../components/Modals/SelectRouteModal";
import CreateNewRouteModal from "../../components/Modals/CreateNewRouteModal";
import PointsListingModal from "../../components/Modals/PointsListingModal";
import ReportSuggestionModal from "../../components/Modals/ReportSuggestionModal";
import ShareModal from "../../components/Modals/ShareModal";
import swal from "sweetalert";
import {
  addUserFavorite,
  removeUserFavorite,
} from "../../services/favourites.service";
import { routeDetail, updateRouteDetail } from "../../services/myRoute.service";
import marked_pop from "../../assets/marked_pop.svg";
import { GoHome } from "react-icons/go";

const containerStyle = {
  width: "100%",
  height: "650px",
};

const options = {
  minZoom: 2,
  maxZoom: 17,
  gestureHandling: "greedy",
};

function ExploreNearBy({ isUserLoggedIn }) {
  const [activeMarker, setActiveMarker] = useState(null);
  const [dropdownMenuOpen, setMenuOpen] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [pointName, setPointName] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [routeName, setRouteName] = useState(null);
  const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
  const [map, setMap] = useState(/**@type window?.google?.maps?.Map*/ (null));
  const [checkForFavorite, setCheckForFavorite] = useState(null);
  const [route, setRoute] = useState(null);
  const [mkmID, setMkmId] = useState();
  const [link, setLink] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const { from } = location?.state || "";
  const { categoryName } = location?.state || "";
  const { categoryTitle } = location?.state || "";

  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );
  const markers = useSelector(
    (state) => state?.pointListReducer?.pointListData
  );
  console.log(markers);

  const dispatch = useDispatch();
  let { poi } = useParams();
  var nearBy = poi?.split(",");

  const toggle = () => {
    setShowModal(!showModal);
    setRoute(null);
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDzh8-GocyaUY-Y1vg21IVA5M0vx6RuqI8",
  });

  const center = {
    lat: Number(nearBy[0]),
    lng: Number(nearBy[1]),
  };

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  useEffect(() => {
    fetchPointList();
  }, []);

  const fetchPointList = async () => {
    try {
      dispatch(showPointList());
    } catch (error) {
      toast.error(
        error?.startPoint?.message ||
          "Oops.. something went wrong, try again !!!",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        }
      );
    }
  };

  const createNewRoute = () => {
    setShowModal(false);
    setShowCreateRouteModal(true);
  };

  const addToRoute = (id) => {
    if (location?.state?.data) {
      if (location?.state?.data[0]?.key === "exploreNearBy") {
        addPointInLast(id);
      } else if (location?.state?.data[0]?.key === "addPoints") {
        addPointInLast(id);
      } else {
        setMkmId(id);
        setShowModal(true);
      }
    } else {
      setMkmId(id);
      setShowModal(true);
    }
  };

  const addPointInLast = async (id) => {
    if (isUserLoggedIn) {
      const arr = location?.state?.data[0]?.arr;
      if (arr?.length < 25) {
        let index = location?.state?.data[0]?.index;
        index = arr.length;
        let requestBody = [];
        arr?.splice(index, 0, {
          mkmID: id,
          orderNumber: 0,
          visited: false,
        });
        requestBody = arr?.map((item, i) => {
          return {
            mkmID: item?.place?.mkmID || item?.mkmID,
            orderNumber: i,
            visited: item?.visited,
          };
        });
        try {
          let res = await updateRouteDetail(requestBody, {
            userName: userName,
            routeID: location?.state?.data[0]?.route_id,
          });
          if (res && res?.status === 200) {
            setActiveMarker(null);
            toast.success("Point Added Successfully In Your Route!", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
            setTimeout(() => {
              navigate(
                `/my-routes-detail/${location?.state?.data[0]?.route_id}/${location?.state?.data[0]?.route_name}`
              );
            }, 1000);
          }
        } catch (err) {
          toast.error(
            err?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      } else {
        toast.warning(
          "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this point in your Route?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const share = (id, poi) => {
    const data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`;
    setLink(data);
    setShowShareModal(true);
  };

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const selectRoute = async () => {
    let existingData;
    if (route?.id) {
      try {
        let response = await routeDetail({
          userName: userName,
          routeID: route?.id,
        });
        if (response && response?.status === 200) {
          existingData = response?.data?.data;
        }

        let requestBody = [];
        if (existingData?.length < 25) {
          if (existingData?.length === 0) {
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 0,
              visited: false,
            });
          } else if (existingData?.length === 1) {
            requestBody?.push({
              mkmID: existingData[0]?.place?.mkmID,
              orderNumber: 0,
              visited: false,
            });
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 1,
              visited: false,
            });
          } else {
            existingData?.splice(existingData?.length, 0, {
              mkmID: mkmID,
              orderNumber: existingData?.length,
              visited: false,
            });
            requestBody = existingData?.map((item, i) => {
              return {
                mkmID: item?.place?.mkmID || item?.mkmID,
                orderNumber: i,
                visited: item?.visited,
              };
            });
          }
          try {
            setShowSpinner(true);
            let res = await updateRouteDetail(requestBody, {
              userName: userName,
              routeID: route?.id,
            });
            if (res && res?.status === 200) {
              setActiveMarker(null);
              toast.success("Point Added Successfully In Your Route!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
              setShowSpinner(false);
            }
          } catch (err) {
            toast.error(
              err?.response?.data?.message ||
                "Oops.. something went wrong, try again !!!",
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              }
            );
            setShowSpinner(false);
          }
          setRoute("");
          setShowModal(false);
        } else {
          toast.warning(
            "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
          setShowSpinner(false);
        }
        setRoute("");
        setShowModal(false);
      } catch (error) {
        console.log(error);
        setShowSpinner(false);
      }
    }
    if (!route?.id) {
      toast.error("Please Select The Route.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      setShowSpinner(false);
    }
  };

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const addToFavorite = async (id, fav) => {
    if (isUserLoggedIn) {
      const willFavorite = await swal({
        title: "Are you sure?",
        text: "You want to add this route in Favorites?",
        icon: marked_pop,
        buttons: true,
      });
      if (willFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId: id,
          };
          const response = await addUserFavorite(data, obj);
          setCheckForFavorite(fav);
          if (response && response?.status === 200) {
            swal(
              "Added!",
              "Your route has been added in Favorites!",
              "success"
            );
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this route in Favorites?",
        icon: marked_pop,
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const removeFromFavorite = async (id, fav) => {
    if (isUserLoggedIn) {
      const willRemoveFavorite = await swal({
        title: "Are you sure?",
        text: "You want to remove this route from Favorites?",
        icon: marked_pop,
        buttons: true,
      });
      if (willRemoveFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId: id,
          };
          const response = await removeUserFavorite(data, obj);
          setCheckForFavorite(fav);
          if (response && response?.status === 200) {
            swal(
              "Removed!",
              "Your route has been removed from Favorites!",
              "success"
            );
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to remove this route from Favorites?",
        icon: marked_pop,
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const exploreNearByCloseInfo = () => {
    setActiveMarker(null);
  };

  const onLoad = useCallback(async function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    bounds?.extend(center);
    map?.fitBounds(bounds);
    setMap(map);
  }, []);

  return (
    <div className="main_section explore_near_me">
      <SelectRouteModal
        route={route}
        setRoute={setRoute}
        showModal={showModal}
        toggle={toggle}
        createNewRoute={createNewRoute}
        selectRoute={selectRoute}
        showSpinner={showSpinner}
      />
      <CreateNewRouteModal
        showCreateRouteModal={showCreateRouteModal}
        setShowCreateRouteModal={setShowCreateRouteModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        routeName={routeName}
        setRouteName={setRouteName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <PointsListingModal
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <ReportSuggestionModal
        showReportModal={showReportModal}
        setShowReportModal={setShowReportModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        mkmID={mkmID}
      />
      <ShareModal
        showShareModal={showShareModal}
        setShowShareModal={setShowShareModal}
        link={link}
        setLink={setLink}
      />
      <Container>
        {/* <SearchBar /> */}
        <div className="breadcrumb_section">
          <Container>
            {location?.state?.data ? (
              location?.state?.data[0]?.key === "exploreNearBy" ? (
                <Breadcrumb className="breadcrumb">
                  <BreadcrumbItem>
                    <Link to="/" className="breadcrumb_item1">
                      Home
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link to="/my-routes" className="breadcrumb_item1">
                      My Routes
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active className="breadcrumb_item2">
                    Explore Near By
                  </BreadcrumbItem>
                </Breadcrumb>
              ) : from === "alongRoute" ? (
                <Breadcrumb className="breadcrumb">
                  <BreadcrumbItem>
                    <Link to="/" className="breadcrumb_item1">
                      Home
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link to="/my-routes" className="breadcrumb_item1">
                      My Routes
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link
                      to="/along-route"
                      state={{ data: location?.state?.data }}
                      className="breadcrumb_item1"
                    >
                      Along Route
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active className="breadcrumb_item2">
                    Explore Near By
                  </BreadcrumbItem>
                </Breadcrumb>
              ) : from === undefined ? (
                <Breadcrumb className="breadcrumb">
                  <BreadcrumbItem>
                    <Link to="/" className="breadcrumb_item1">
                      Home
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link to="/my-routes" className="breadcrumb_item1">
                      My Routes
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active className="breadcrumb_item2">
                    Explore Near By
                  </BreadcrumbItem>
                </Breadcrumb>
              ) : from === "addMorePointToRoute" ? (
                <Breadcrumb className="breadcrumb">
                  <BreadcrumbItem>
                    <Link to="/" className="breadcrumb_item1">
                      Home
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link to="/my-routes" className="breadcrumb_item1">
                      My Routes
                    </Link>
                    <span className="breadcrumb-divider">
                      <MdOutlineNavigateNext />
                    </span>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link
                      to="/add-more-points-to-route"
                      state={{ data: location?.state?.data }}
                      className="breadcrumb_item1"
                    >
                      Add more points to route
                    </Link>
                    <span className="breadcrumb-divider">
                      <MdOutlineNavigateNext />
                    </span>
                  </BreadcrumbItem>
                  <BreadcrumbItem active className="breadcrumb_item2">
                    Explore Near By
                  </BreadcrumbItem>
                </Breadcrumb>
              ) : from === "customAddress" ? (
                <Breadcrumb className="breadcrumb">
                  <BreadcrumbItem>
                    <Link to="/" className="breadcrumb_item1">
                      Home
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link to="/my-routes" className="breadcrumb_item1">
                      My Routes
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link
                      to="/search-custom-point"
                      state={{ data: location?.state?.data }}
                      className="breadcrumb_item1"
                    >
                      Custom Address
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active className="breadcrumb_item2">
                    Explore Near By
                  </BreadcrumbItem>
                </Breadcrumb>
              ) : from === "alongPreviousPoint" ? (
                <Breadcrumb className="breadcrumb">
                  <BreadcrumbItem>
                    <Link to="/" className="breadcrumb_item1">
                      Home
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link to="/my-routes" className="breadcrumb_item1">
                      My Routes
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link
                      to="/along-route-previous-point"
                      state={{
                        from: "alongPreviousPoint",
                        data: location?.state?.data,
                      }}
                      className="breadcrumb_item1"
                    >
                      Along Route from Point{" "}
                      <span className="pointName">
                        {location?.state?.data[1]?.place?.title}
                      </span>{" "}
                      and Point{" "}
                      <span className="pointName">
                        {location?.state?.data[0]?.place?.title}
                      </span>
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active className="breadcrumb_item2">
                    Explore Near By
                  </BreadcrumbItem>
                </Breadcrumb>
              ) : from === "routeDetail" ? (
                <Breadcrumb className="breadcrumb">
                  <BreadcrumbItem>
                    <Link to="/" className="breadcrumb_item1">
                      Home
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link to="/my-routes" className="breadcrumb_item1">
                      My Routes
                    </Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active className="breadcrumb_item2">
                    Explore Near By
                  </BreadcrumbItem>
                </Breadcrumb>
              ) : from === "searchEverywhere" ? (
                <Breadcrumb className="breadcrumb">
                  <BreadcrumbItem>
                    <Link to="/" className="breadcrumb_item1">
                      <GoHome />
                    </Link>
                    <span className="breadcrumb-divider">
                      <MdOutlineNavigateNext />
                    </span>
                  </BreadcrumbItem>
                  <BreadcrumbItem>
                    <Link
                      to="/search-everywhere"
                      state={{
                        data: location?.state?.data,
                        key: location?.state?.key,
                      }}
                      className="breadcrumb_item1"
                    >
                      Categorie
                    </Link>
                    <span className="breadcrumb-divider">
                      <MdOutlineNavigateNext />
                    </span>
                  </BreadcrumbItem>
                  <BreadcrumbItem active className="breadcrumb_item2">
                    Explore Near By
                  </BreadcrumbItem>
                </Breadcrumb>
              ) : (
                <></>
              )
            ) : from === "exploreNearMe" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/explore-near-me" className="breadcrumb_item1">
                    Explore Near Me
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Explore Near By
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "routeDetail" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/my-routes" className="breadcrumb_item1">
                    My Routes
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Explore Near By
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "favourite" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    <GoHome />
                  </Link>
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/favourites" className="breadcrumb_item1">
                    Favourites
                  </Link>
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Explore Near By
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "routeDetailExploreNearBy" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/my-routes" className="breadcrumb_item1">
                    My Routes
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Explore Near By
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "topPlaces" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Top Places
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Explore Near By
                </BreadcrumbItem>
              </Breadcrumb>
            ) : (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    <GoHome className="home_icon" />
                  </Link>

                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Category
                  </Link>
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link
                    to="/category-list"
                    state={{
                      categoryName: categoryName,
                      categoryTitle: categoryTitle,
                    }}
                    className="breadcrumb_item1"
                  >
                    {categoryName}
                  </Link>
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Explore Near By
                </BreadcrumbItem>
              </Breadcrumb>
            )}
          </Container>
        </div>
        <div className="explore_near_me_section">
          <Container fluid>
            <div className="explore_near_me_box">
              <div className="map">
                {isLoaded ? (
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    onLoad={onLoad}
                    options={options}
                    zoom={12}
                  >
                    {markers?.map((item) => (
                      <div key={item?.poi}>
                        <Marker
                          position={{
                            lat: Number(item?.poi?.split(",")[0]),
                            lng: Number(item?.poi?.split(",")[1]),
                          }}
                          onClick={() => handleActiveMarker(item?.id)}
                          onLoad={(marker) => {
                            const customIcon = (opts) =>
                              Object.assign(
                                {
                                  path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z",
                                  fillColor: "#34495e",
                                  fillOpacity: 1,
                                  strokeColor: "teal",
                                  strokeWeight: 2,
                                  scale: 1,
                                },
                                opts
                              );
                            item?.categoryId === 1
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "#d2b48c",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 10
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "teal",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 5
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "turquoise",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 4
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "gold",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 2
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "#000080",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 7
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "#00ffff",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 9
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "tomato",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 12
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "wheat",
                                    strokeColor: "white",
                                  })
                                )
                              : marker.setIcon(
                                  customIcon({ fillColor: "wheat" })
                                );
                            return handleActiveMarker(marker, item);
                          }}
                        >
                          {activeMarker === item?.id ? (
                            <InfoWindow
                              onCloseClick={() => setActiveMarker(null)}
                            >
                              <div className="info_window">
                                <Card body>
                                  <div className="card_header">
                                    {item?.userFavorite === true ? (
                                      <Button
                                        className="favourite_fill_icon"
                                        onClick={() =>
                                          removeFromFavorite(item?.id)
                                        }
                                      >
                                        <AiFillStar size={20} />
                                      </Button>
                                    ) : (
                                      <Button
                                        className="favourite_icon"
                                        onClick={() => addToFavorite(item?.id)}
                                      >
                                        <AiOutlineStar size={20} />
                                      </Button>
                                    )}
                                    <div className="right_section">
                                      {from === "alongRoute" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "alongRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "addMorePointToRoute" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "addMorePointToRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "customAddress" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "customAddress",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "routeDetail" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "routeDetail",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "alongPreviousPoint" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "alongPreviousPoint",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "exploreNearMe" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "exploreNearMe",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "favourite" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "favourite",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from ===
                                        "routeDetailExploreNearBy" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "routeDetailExploreNearBy",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "topPlaces" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "topPlaces",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "searchEverywhere" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "searchEverywhere",
                                            data: location?.state?.data,
                                            key: location?.state?.key,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            categoryName: categoryName,
                                            categoryTitle: categoryTitle,
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      )}
                                      <Dropdown
                                        className="moreInfo"
                                        toggle={() => {
                                          setMenuOpen(!dropdownMenuOpen);
                                        }}
                                        isOpen={dropdownMenuOpen}
                                      >
                                        <DropdownToggle>
                                          <BiDotsVerticalRounded size={20} />
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem>
                                            {from === "alongRoute" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "alongRoute",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from ===
                                              "addMorePointToRoute" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "addMorePointToRoute",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "customAddress" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "customAddress",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "routeDetail" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "routeDetail",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from ===
                                              "alongPreviousPoint" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "alongPreviousPoint",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "exploreNearMe" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "exploreNearMe",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "favourite" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "favourite",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from ===
                                              "routeDetailExploreNearBy" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "routeDetailExploreNearBy",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "topPlaces" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "topPlaces",
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "searchEverywhere" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "searchEverywhere",
                                                  data: location?.state?.data,
                                                  key: location?.state?.key,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  categoryName: categoryName,
                                                  categoryTitle: categoryTitle,
                                                  data: location?.state?.data,
                                                }}
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            )}
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={() =>
                                              reportSuggestion(
                                                item?.mkmTitle,
                                                item?.id
                                              )
                                            }
                                          >
                                            Report suggestion
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                    </div>
                                  </div>
                                  <CardText className="grid_text_le">
                                    {item?.cityY + " "} &nbsp; {item?.stateY}
                                  </CardText>
                                  <div className="card_bottom">
                                    <Button
                                      onClick={() => share(item?.id, item?.poi)}
                                    >
                                      <FiShare2 size={20} />
                                    </Button>
                                    <div className="right_section">
                                      <CardText>
                                        {item?.cityE + " " + item?.stateE}
                                      </CardText>
                                      <MdLocationOn
                                        className="location_icon"
                                        size={18}
                                      />
                                    </div>
                                  </div>
                                  <div className="card_footer">
                                    {from === "alongRoute" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "alongRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "alongRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "addMorePointToRoute" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "addMorePointToRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "addMorePointToRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "customAddress" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "customAddress",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "customAddress",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "routeDetail" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "routeDetail",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "routeDetail",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "alongPreviousPoint" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "alongPreviousPoint",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "alongPreviousPoint",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "exploreNearMe" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "exploreNearMe",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "exploreNearMe",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "favourite" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "favourite",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "favourite",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "routeDetailExploreNearBy" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "routeDetailExploreNearBy",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "routeDetailExploreNearBy",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "topPlaces" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "topPlaces",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "topPlaces",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "searchEverywhere" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            from: "searchEverywhere",
                                            data: location?.state?.data,
                                            key: location?.state?.key,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "searchEverywhere",
                                            data: location?.state?.data,
                                            key: location?.state?.key,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          onClick={exploreNearByCloseInfo}
                                          state={{
                                            categoryName: categoryName,
                                            categoryTitle: categoryTitle,
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            categoryName: categoryName,
                                            categoryTitle: categoryTitle,
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    )}
                                    <Button
                                      className="btn addroute"
                                      onClick={() => addToRoute(item?.id)}
                                    >
                                      <FiBriefcase className="addroute_icon" />
                                      Add to Route
                                    </Button>
                                  </div>
                                </Card>
                              </div>
                            </InfoWindow>
                          ) : null}
                        </Marker>
                        <Marker
                          position={{
                            lat: Number(nearBy[0]),
                            lng: Number(nearBy[1]),
                          }}
                          icon={{
                            url: "http://maps.google.com/mapfiles/ms/icons/orange-dot.png",
                          }}
                        />
                      </div>
                    ))}
                  </GoogleMap>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </Container>
        </div>
      </Container>
    </div>
  );
}

export default ExploreNearBy;
